import { fabric } from 'fabric';
import { ANNOTATION_TYPE } from '@/shared/ui';

type BookmarkIndicatorCtor = new (
  cv: fabric.Canvas,
  sampleIndex: number,
  offsetX: number,
  config: any,
  id: string,
) => any;

let BookmarkIndicatorImpl: any;

(function () {
  const STROKE = {
    strokeWidth: 1,
    selectable: false,
    hasBorders: false,
    stroke: '#00B268',
    strokeDashArray: [5, 5],
    originX: 'center',
    originY: 'center',
  };

  BookmarkIndicatorImpl = function (
    cv: fabric.Canvas,
    sampleIndex: number,
    offsetX: number,
    config: any,
    id: string,
  ) {
    this.type = ANNOTATION_TYPE.BOOKMARK_INDICATOR;
    this.canvas = cv;
    this.config = config;
    this.isVisible = true;
    this.xr = sampleIndex;
    this.spp = (config.samplingRate * config.wndDuration) / config.width;
    this.x = this.xr > offsetX ? (this.xr - offsetX) / this.spp : this.xr / this.spp;
    this.id = id;
  };

  BookmarkIndicatorImpl.prototype.draw = function (sampleIndex: number, offsetX: number) {
    this.xr = sampleIndex;
    this.x = (this.xr - offsetX) / this.spp;
    this.line = new fabric.Line([this.x, 1, this.x, this.config.height - 17], STROKE);
    this.line.id = 'line';
    this.canvas.add(this.line);
    this.polyline = new fabric.Polyline(
      [
        { x: 8, y: 0 },
        { x: 8, y: 12 },
        { x: 4, y: 8 },
        { x: 0, y: 12 },
        { x: 0, y: 0 },
      ],
      {
        top: this.config.height - 10,
        left: this.x,
        fill: '#00B268',
        selectable: false,
        strokeLineJoin: 'round',
        strokeWidth: 1,
        originX: 'center',
        originY: 'center',
      },
    );
    this.canvas.add(this.polyline);
  };

  BookmarkIndicatorImpl.prototype.render = function () {
    this.canvas.renderAll();
  };

  BookmarkIndicatorImpl.prototype.update = function (sampleIndex: number, offsetX: number) {
    this.xr = sampleIndex;
    this.x = (this.xr - offsetX) / this.spp;
    if (this.line && this.polyline) {
      this.line.set({ x1: this.x, x2: this.x });
      this.line.setCoords();
      this.polyline.set({ left: this.x });
      this.polyline.setCoords();
    }
  };

  BookmarkIndicatorImpl.prototype.updateConfig = function () {};

  BookmarkIndicatorImpl.prototype.scroll = function (offsetX: number) {
    this.x = (this.xr - offsetX) / this.spp;
    if (this.line && this.polyline) {
      this.line.set({ x1: this.x, x2: this.x });
      this.line.setCoords();
      this.polyline.set({ left: this.x });
      this.polyline.setCoords();
    }
  };

  BookmarkIndicatorImpl.prototype.isSelected = function (pointer: any) {
    return false; // Can not select this annotation
  };

  BookmarkIndicatorImpl.prototype.select = function () {
    // Can not select this annotation
  };

  BookmarkIndicatorImpl.prototype.deselect = function () {
    // Can not deselect this annotation
  };

  BookmarkIndicatorImpl.prototype.isVisibility = function (isVisibility: boolean) {
    this.line.visible = isVisibility;
    this.polyline.visible = isVisibility;
  };

  BookmarkIndicatorImpl.prototype.getJSONObject = function () {
    return {
      type: this.type,
      position: this.xr,
    };
  };

  BookmarkIndicatorImpl.prototype.import = function (data: any) {
    // This object import by create instance
  };
})();

const BookmarkIndicator: BookmarkIndicatorCtor = BookmarkIndicatorImpl;

export { BookmarkIndicator };
export default { BookmarkIndicator };
